<template>
    <div v-if="Object.keys(searchFilters).length !== 0" class="mt-3">
        <div v-for="(filterValues, filterGroupName, index) in searchFilters" :key="index">
            <date-range-filter-card v-if="filterGroupName == 'period' && filterValues['min'] && filterValues['max']"
                                    :min="filterValues['min']"
                                    :max="filterValues['max']"
                                    :start="filterValues['start']"
                                    :end="filterValues['end']"
                                    :filter-name="filterGroupName"
                                    :selected-filters="getSelectedFilters(filterGroupName)"
                                    :referrer-url="referrerUrl">
            </date-range-filter-card>

            <search-filter-card v-else
                                :buckets="filterValues.buckets || []"
                                :filter-name="filterGroupName"
                                :selected-filters="getSelectedFilters(filterGroupName)"
                                :referrer-url="referrerUrl"
                                :translate-values="shouldTranslateValues(filterGroupName)"
                                :show-heading="shouldShowHeading(filterGroupName)"
                                :number-of-filter-values="numberOfValuesPerCategory">
            </search-filter-card>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            searchFilters: { type: Object, required: true },
            selectedFilters: { type: Object, required: true },
            referrerUrl: { type: String, required: true },
            filterCategoriesWithTranslatedValues: { type: Array, required: false, default: () => [] },
            filterCategoriesWithoutHeading: { type: Array, required: false, default: () => [] },
            numberOfValuesPerCategory: { type: Number, required: false }
        },

        methods: {
            getSelectedFilters(filterName) {
                return this.selectedFilters[filterName] !== undefined ? this.selectedFilters[filterName] : [];
            },

            shouldTranslateValues(filterGroupName) {
                // return whether the filter group name is in the list of categories to translate values for
                return this.filterCategoriesWithTranslatedValues.indexOf(filterGroupName) !== -1;
            },

            shouldShowHeading(filterGroupName) {
                // return whether the filter group name is in the list of categories without heading
                return this.filterCategoriesWithoutHeading.indexOf(filterGroupName) === -1;
            }
        }
    }
</script>